import { useQueryClient } from 'react-query';
import {
  useTracking,
  setTrackView,
  setTrackLink,
  setTrackWithNewDatalayer,
} from '@vfit/shared/data-access';
import { removeCurrency } from '@vfit/consumer/hooks';
import { isAppLockin } from './shoppingCart.utils';
import { useCheckout } from '../iBuyFixed.context';
import { getTagging, getUserInfo } from '../Checkout/checkout.utils';

const ShoppingCartTagging = () => {
  const { product } = useCheckout();
  const queryClient = useQueryClient();
  const tagging = getTagging('cart', 'fixed', queryClient);
  const { trackWithNewDatalayer, trackView } = useTracking({
    event: ['cart_view'],
    opts: tagging?.opts,
    cartProduct: {
      ...tagging?.trackingProduct,
      cart_total: product?.price && removeCurrency(product.price),
    },
    pageProduct: tagging?.pageProductsInfo,
    visitorTrackingOpts: getUserInfo(),
    disableInitialTrack: isAppLockin(),
  });
  setTrackView(trackView);
  setTrackLink(trackView);
  setTrackWithNewDatalayer(trackWithNewDatalayer);

  return null;
};

export default ShoppingCartTagging;
